import * as React from 'react';

/**
 * Hook to know when the component is mounted.
 */
export function useIsMounted(): React.RefObject<boolean> {
    const isMounted = React.useRef(false);

    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted;
}
